import Typeahead from './Typeahead.component';

export default Typeahead;
